export function convertSizeUnit(from, to, value) {
    const parsedValue = parseFloat(`${value}`);

    const fromUnit = from.toLowerCase()
    const toUnit = to.toLowerCase();
    let convertedUnit = "";

    if(fromUnit === toUnit) {
      convertedUnit =  `${parsedValue.toFixed(1)}`;
    } else if(toUnit == "in") {
      convertedUnit =  `${(parsedValue / 2.54).toFixed(1)}`;
    } else {
      convertedUnit =  `${(parsedValue * 2.54).toFixed(1)}`;
    }
  
    return convertedUnit;
}

export const calculateDiscountedPrice = (price, discountValue, discountType) => {
  if(discountType == 'percentage')
    return price - Math.round((price * discountValue) / 100);

  return price - discountValue;
}

const roundPrice = (price) => Math.ceil(price).toFixed(2); // parseFloat(parseFloat(price.toFixed(2)).toFixed(1)).toFixed(2);

export const formatPrice = (price, currencyConversion) => {
  const { currency, currencySymbol, currencyConversionRate = 1 } = currencyConversion;
  const isCurrencyConvNeeded = currencySymbol?.trim()?.length > 0;

  if (isCurrencyConvNeeded) {
    return `${currencySymbol}${roundPrice(price * currencyConversionRate)}`
  }

  return Intl.NumberFormat("en-IN", {
    "currency": currency,
    "style": "currency",
    "maximumFractionDigits": 0
  }).format(price)
}

export const getCookie = (cookieName) => {
  var cookiestring = RegExp(cookieName + "=[^;]+").exec(document.cookie);
  return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
}
// Tiny replacements for the only two lodash helpers the hero used; lodash alone was ~70KB of the
// addToBagHelper chunk on every product page.

// Trailing-edge throttle: runs `fn` at most once per `waitMs`, always with the latest args.
export const throttle = (fn, waitMs) => {
  let timer = null;
  let lastArgs = null;
  return (...args) => {
    lastArgs = args;
    if (timer) return;
    timer = setTimeout(() => {
      timer = null;
      fn(...lastArgs);
    }, waitMs);
  };
};

// Up to `count` distinct random elements of `items` (Fisher–Yates on a copy; input untouched).
export const sampleSize = (items, count) => {
  const pool = [...items];
  for (let i = pool.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, Math.max(0, Math.min(count, pool.length)));
};
